
<template>
  <div class="count">
    <div class="icon-wrap">
      <div class="back">
        <IconBase ref="iconbase" />
      </div>
      <div class="front">
        <img :src="url" alt="">
      </div>
    </div>
    <div class="content">
      <div class="title ft-14">{{ title }}</div>
      <div class="conter-wrap">
        <div class="conter ff-tt ft-40">
          <ICountUp
            :startVal="0"
            :endVal="0"
            :decimals="0"
            :duration="2.4"
            :options="options"
            @ready="onReady"
          />
        </div>
        <div class="unit">
          <slot></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import IconBase from '@/components/IconBase.vue'
import ICountUp from 'vue-countup-v2'

export default {
  components: {
    IconBase,
    ICountUp
  },

  props: {
    url: String,
    title: String,
    num: Number
  },

  data () {
    return {
      canPlay: false,
      options: {
        useEasing: true,
        useGrouping: true,
        separator: '',
        decimal: '',
        prefix: '',
        suffix: ''
      }
    }
  },

  methods: {
    run () {
      if (this.canPlay) {
        this.$refs.iconbase.play()
        this.instance.update(this.num)
        this.canPlay = false
        return
      }
      this.canPlay = true
    },
    onReady (instance) {
      this.instance = instance
      this.run()
    },

    play () {
      this.$nextTick(() => {
        this.run()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.count {
  display: flex;
}

.icon-wrap {
  position: relative;
  width: 90px;
  height: 90px;

  .back, .front {
    width: 90px;
    height: 90px;
    position: absolute;
    top: 0;
    left: 0;
  }

  .front {
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

.content {
  margin: 0 26px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;

  .title {
    color: #83949b;
  }
}

.conter-wrap {
  display: flex;

  .conter {
    min-width: 130px;
    color: #83949b;
  }

  .unit {
    display: flex;
  }
}
</style>
